import { useEffect, useState, useCallback } from 'react';
import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { performPostRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller/src/components/tenant-context/index.tsx';
import { BULK_CHANGE_PERMISSION_QUERY } from './gql.tsx';
import type { GetBulkChangePermissionResponse } from './types.tsx';

export const useBulkChangePermissionService = () => {
	const { cloudId } = useTenantContext();

	const [bulkChangePermission, setPermission] = useState<boolean>();

	const getBulkChangePermission = useCallback(async () => {
		try {
			const gqlResponse = await performPostRequest<GetBulkChangePermissionResponse>(
				'/gateway/api/graphql',
				{
					body: JSON.stringify({
						query: BULK_CHANGE_PERMISSION_QUERY,
						variables: {
							cloudId,
						},
					}),
				},
			);
			setPermission(gqlResponse?.data?.jira?.permission?.hasPermission ?? false);
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			fireErrorAnalytics({
				meta: {
					id: 'fetchBulkChangePermission',
					packageName: 'jiraBusinessList',
					teamName: 'keystone',
				},
				attributes: {
					message: 'Failed to get bulk change permission.',
				},
				error,
				sendToPrivacyUnsafeSplunk: true,
			});
			setPermission(false);
		}
	}, [cloudId]);

	useEffect(() => {
		if (!cloudId) return;
		getBulkChangePermission();
	}, [getBulkChangePermission, cloudId]);

	return bulkChangePermission;
};
